import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Router from './routes';
import 'react-toastify/dist/ReactToastify.css';
import 'react-spring-bottom-sheet/dist/style.css';
import './App.css';
import useNetworkStatus from '@/hooks/network-status/useNetworkStatus';
import OffLine from '@/components/offline';
import Container from '@/components/@base/container';
import DevelopmentNote from '@/components/development-note';
import { useEffect } from 'react';
// import TagManager from './components/tagManager';
import ThemeColorSyncLite from '@/components/@base/theme-color-sync-lite/ThemeColorSyncLite';
import Cdxp from '@/components/cdxp';

function App() {
  useEffect(() => {
    if (typeof globalThis === 'undefined') {
      (function () {
        // polyfill for globalThis
        Object.defineProperty(Object.prototype, 'globalThis', {
          get: function () {
            return this;
          },
        });
      })();
    }
  }, []);
  const queryClient = new QueryClient();
  const { isOnline } = useNetworkStatus();
  return (
    <QueryClientProvider client={queryClient}>
      {/*<TagManager/>*/}
      <Cdxp />
      {!isOnline && <OffLine />}
      <ThemeColorSyncLite />
      <Container className='lg:dark:grayLight-990 relative m-auto flex min-h-screen max-w-[448px] flex-col bg-grayLight-0 md:h-full lg:h-full lg:max-w-[1920px] dark:bg-grayLight-990'>
        <DevelopmentNote />
        <Router />
      </Container>
      <ToastContainer
        position='top-center'
        autoClose={3000}
        hideProgressBar
        newestOnTop={true}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        closeButton={false}
      />
    </QueryClientProvider>
  );
}

export default App;
